export enum SharingRecipientType {
  user = 'user',
  team = 'team',
  company = 'company',
  instance = 'instance',
}
